import 'lazysizes';

function imageLazyLoading() {
    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if (bg) {
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });
}


imageLazyLoading();

export default imageLazyLoading;
